import React from 'react';

const StartButton = ({ onToggle, id, isStarted }) => {
    //const [isStarted, setIsStarted] = useState(false);
  
    const handleClick = () => {
        onToggle(!isStarted);
      };

  return (
    <button 
    onClick={handleClick}
    className={'btn btn-outline-info custom-end-button btn-block mt-2 w-25'}
    id={id}
    >
      {isStarted ? 'End' : 'Start'}
    </button>
  );
};

export default StartButton;